import { searchFolders } from 'SalesContentIndexUI/api/FoldersApi';
export function loadFolderOptions(folderContentType, searchInput, callback) {
  return searchFolders({
    folderContentType,
    searchInput
  }).then(resp => resp.results.map(folderResult => ({
    text: folderResult.name,
    value: folderResult.contentId
  }))).then(options => callback(null, {
    options
  }));
}